import { createApi } from "@reduxjs/toolkit/query/react";
import { gql } from "graphql-request";
import customBaseQuery from "../../../utils/customBaseQuery";
import { SearchUserNameApiType } from "@lxp-app/pages/event-review/Utils/pidApiUserType";

export const UserSearchAPi = createApi({
  reducerPath: "userSearchApi",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    getSearchUserByIdAndNameOrEmail: builder.query({
      query: ({ key, pageNo, pageCount }: SearchUserNameApiType) => ({
        url: "/graphql",
        body: gql`
            query{
                searchByIdAndNameOrEmailPaginated(
                    request: {key: "${key}"},
                    sortCriteria: {sortKey: "", order: "ASC", pageNo: ${pageNo}, pageCount: ${pageCount}}
                  ) {
                    error
                    data {
                      notAvailable
                      profiles {
                        id
                        name {
                
                          fullName
                        }
                        email
                      }
                      pageNo
                      pageCount
                      totalCount
                    }
                  }
            }
          `
      }),
      extraOptions: {
        service: "PID"
      },
      serializeQueryArgs: ({ queryArgs }) => {
        return "sss";
      },
      merge(currentCacheData, responseData, otherArgs: any) {
        if (responseData.searchByIdAndNameOrEmailPaginated.data?.pageNo > 1) {
          const messageMap = new Map();
          [
            ...currentCacheData.searchByIdAndNameOrEmailPaginated.data.profiles,
            ...responseData.searchByIdAndNameOrEmailPaginated.data.profiles
          ].map((msg) => {
            if (!messageMap.has(msg.id)) {
              messageMap.set(msg.id, msg);
            }
          });
          const mergedResult = [...messageMap.values()];
          return {
            ...responseData,
            searchByIdAndNameOrEmailPaginated: {
              ...responseData.searchByIdAndNameOrEmailPaginated,
              data: {
                ...responseData.searchByIdAndNameOrEmailPaginated.data,
                profiles: mergedResult
              }
            }
          };
        } else return responseData;
      }
    })
  })
});

export const {
  useLazyGetSearchUserByIdAndNameOrEmailQuery,
  useGetSearchUserByIdAndNameOrEmailQuery
} = UserSearchAPi;
